import { Fancybox } from "@fancyapps/ui";


import { gsap } from "gsap";
document.addEventListener("DOMContentLoaded", function() {
    const tabs = document.querySelectorAll(".tab__trigger");
    const contents = document.querySelectorAll(".content-tab");

    // Imposta la prima tab e il primo contenuto come attivi per default
    if (tabs.length > 0 && contents.length > 0) {
        tabs[0].classList.add("active");
        contents[0].classList.add("active");
        contents[0].style.display = 'block';
    }

    tabs.forEach(tab => {
        tab.addEventListener("click", (event) => {
            const currentActiveContent = document.querySelector(".content-tab.active");
            if (currentActiveContent) {
                gsap.to(currentActiveContent, {
                    duration: 0.5,
                    autoAlpha: 0,
                    onComplete: () => {
                        currentActiveContent.classList.remove("active");
                        currentActiveContent.style.display = 'none';
                        activateNewContent.call(tab, tabs); // Chiama la funzione con il contesto corretto
                    }
                });
            } else {
                activateNewContent.call(tab, tabs); // Chiama la funzione con il contesto corretto
            }
        });
    });
});

function activateNewContent(tabs) {
    const contentId = this.getAttribute("data-index"); // Assicurati che sia 'data-index'
    const content = document.getElementById(contentId);
    tabs.forEach(t => t.classList.remove("active"));
    this.classList.add("active");
    if (content) {
        content.style.display = 'block';
        content.classList.add("active");
        gsap.fromTo(content, {
            autoAlpha: 0
        }, {
            duration: 0.5,
            autoAlpha: 1
        });
    } else {
        console.error("Elemento non trovato: ", contentId);
    }
}
